define('page/detail/popwin', [
    'jquery',
    'widget/dialog/success',
    'data/intent',
    'widget/price-sliderbar',
    'common/appoint',
    'common/util',
    'log',
    'md5',
    'js-cookie',
    'data/local-storage',
], ($, dialog, intent, slidebar, appoint, util, log, md5, Cookies, localCache) => { // eslint-disable-line
    const COOKIE_POPWIN_SHOW_COUNT = 'popwin-show-time'; // 弹出次数
    const COOKIE_POPWIN_LAST_SHOW = 'popwin-show'; // 上次弹出时间
    let isFirstSubmitFullPrice = true; // 判断弹层是否第一次提交降价通知
    const CACHE_VIEW_COUNT = 'userViewCarCount'; // 用户浏览车的次数
    const CACHE_TIME = 100 * 365 * 24 * 3600; // 缓存100年
    const cookieDomain = RRC.cookieDomain || 'renrenche.com';
    let discount_pirce; // 降价通知价格

    let jjMessage = util.getPCIntentSuccessTips('jiangjia');
    if (Array.isArray(jjMessage)) {
        jjMessage = jjMessage.map(item => `<p style="margin-bottom: 5px;">${item}</p>`).join('');
    }
    const remind = `<div class="confirm__message">${jjMessage}</div>`;

    return {
        COOKIE_POPWIN_SHOW_COUNT,
        COOKIE_POPWIN_LAST_SHOW,

        // 获取用户浏览数据json
        getUserviewJson() {
            const userViewCarsStr = localCache.getItem(CACHE_VIEW_COUNT);
            let userViewCarList = {};
            if (userViewCarsStr) {
                userViewCarList = JSON.parse(userViewCarsStr);
            }
            return userViewCarList;
        },
        // 获取当前车浏览次数
        getUserViewCarCount() {
            const viewJson = this.getUserviewJson();
            const userViewCarCount = parseInt(viewJson[RRC.car_encrypt_id], 10) || 0;
            return userViewCarCount;
        },

        // 是否展示弹层
        canShowPopWin() {
            if (RRC.isSpider) {
                return false;
            }
            // 是否为下架车, 下架车不显示
            if ($('#sold_button').length) {
                return false;
            }
            // 特殊 fr 不展示
            if (['2309'].indexOf(RRC.fr) !== -1) {
                return;
            }

            const showCount = parseInt(Cookies.get(COOKIE_POPWIN_SHOW_COUNT), 10) || 0;
            // pc端总共最多弹7次, 同一辆车详情页只允许打开1次60s弹层
            if (showCount < 7 && this.getUserViewCarCount() < 1) {
                return true;
            }

            return false;
        },

        // 展示弹层
        showPopWinModal(popType, time = 60000) {
            const self = this;
            /* istanbul ignore next */
            setTimeout(() => {
                if ($('.modal-backdrop').length === 0 && RRC.SHOW_DETAIL_LAYER_MASK && RRC.GIFT_PACKAGE_BOOKING) {
                    const showCount = parseInt(Cookies.get(COOKIE_POPWIN_SHOW_COUNT), 10) || 0;
                    const userviewCarNum = self.getUserViewCarCount();
                    if (showCount < 7 && userviewCarNum < 1) {
                        Cookies.set(COOKIE_POPWIN_SHOW_COUNT, showCount + 1, { expires: 1, domain: cookieDomain });
                        Cookies.set(COOKIE_POPWIN_LAST_SHOW, Date.now(), { expires: 1, domain: cookieDomain });

                        const viewJson = self.getUserviewJson();
                        viewJson[RRC.car_encrypt_id] = userviewCarNum + 1;
                        localCache.setItem(CACHE_VIEW_COUNT, JSON.stringify(viewJson), CACHE_TIME);

                        if (popType === 'appointment') {
                            this.setPopwinContent('喜欢这款车？', '立即约车主见面看车！', '请输入您的手机号', '详情页线索引导弹层-预约看车', 'appointment');
                        } else {
                            this.setPopwinContent('降价立即通知您！', '本车降价，第一时间告知！', '请输入您的手机号', '详情页线索引导弹层-降价通知', 'discount');
                        }

                        RRC.SHOW_DETAIL_LAYER_MASK = false;
                    }
                }
            }, time);
        },

        // 初始化设置弹层内容
        setPopwinContent(title, msg, placeholder, eventscope, popType) {
            const ndDetailPopwin = $('#js-detail-popwin'); // 弹出窗口
            const ndMobilePopwin = $('#popwin_mobile_number'); // 手机号或价格 (弹出砍价层时为价格)
            const ndSubmitPopwin = $(`#js-popwin-submit-${popType}`);
            ndDetailPopwin.find('.btn-schedule').hide();
            if (Cookies.get('rrc_login_phone') && popType !== 'bargain') {
                ndMobilePopwin.val(Cookies.get('rrc_login_phone'));
            }
            $('#js-popwin-title').html(title);
            $('#js-popwin-msg').html(msg);
            ndSubmitPopwin.show();
            ndMobilePopwin.attr('placeholder', placeholder);
            ndDetailPopwin.attr('rrc-event-scope', eventscope).fullscreen('show');
            this.submitPopWin(popType);
            log.push(['_trackEvent', `pc-car-detail-${eventscope}-弹出`, 'click', { car_id: $('.detail-wrapper').attr('data-encrypt-id') }]);
        },

        /*
        ** Abtest 降价弹层样式  开始***
        */
        // 展示弹层
        showPopWinModalAbtest(popType, time = 60000) {
            const self = this;
            /* istanbul ignore next */
            setTimeout(() => {
                if ($('.modal-backdrop').length === 0 && RRC.SHOW_DETAIL_LAYER_MASK && RRC.GIFT_PACKAGE_BOOKING) {
                    const showCount = parseInt(Cookies.get(COOKIE_POPWIN_SHOW_COUNT), 10) || 0;
                    const userviewCarNum = self.getUserViewCarCount();
                    if (showCount < 7 && userviewCarNum < 1) {
                        Cookies.set(COOKIE_POPWIN_SHOW_COUNT, showCount + 1, { expires: 1, domain: cookieDomain });
                        Cookies.set(COOKIE_POPWIN_LAST_SHOW, Date.now(), { expires: 1, domain: cookieDomain });

                        const viewJson = self.getUserviewJson();
                        viewJson[RRC.car_encrypt_id] = userviewCarNum + 1;
                        localCache.setItem(CACHE_VIEW_COUNT, JSON.stringify(viewJson), CACHE_TIME);

                        if (popType === 'appointment') {
                            this.setPopwinContentAbtest('详情页线索引导弹层-预约看车', 'appointment', '预约-PC-详情页-1'); // eslint-disable-line
                        } else if (window.sell_on_consignment === 1) {
                                this.setPopwinContentAbtest('详情页线索引导弹层-降价通知', 'discount', '申领补贴-PC-详情页-5','申领补贴'); // eslint-disable-line
                        } else {
                                this.setPopwinContentAbtest('详情页线索引导弹层-降价通知', 'discount', '降价-PC-详情页-1'); // eslint-disable-line
                        }
                        Cookies.set(COOKIE_POPWIN_LAST_SHOW, Date.now(), { expires: 1, domain: cookieDomain });
                        Cookies.set(COOKIE_POPWIN_SHOW_COUNT, showCount + 1, { expires: 1, domain: cookieDomain });
                        RRC.SHOW_DETAIL_LAYER_MASK = false;
                    }
                }
            }, time);
        },

        // 初始化设置弹层内容
        setPopwinContentAbtest(eventscope, popType, submitsource,sub_product) { // eslint-disable-line
            const that = this;
            const ndDetailPopwin = $('#js-detail-popwin-abtest'); // 弹出窗口
            const ndMobilePopwin = $('#popwin-mobile-number'); // 手机号或价格 (弹出砍价层时为价格)
            const ndSubmitPopwin = $('#js-popwin-submit');
            const ndInfotPopwin = $(`.popwin-info-${popType}`); //  建议价最低价
            const LOWPRICE = (RRC.adjust_data || 0) && RRC.adjust_data.individual_low_price; // 建议价最高价
            const HIGHPRICE = RRC.adjust_data.individual_high_price;
            const LOWDISCOUNT = 0.7; // 滑动条左侧最低折扣价
            if (Cookies.get('rrc_login_phone')) {
                ndMobilePopwin.val(Cookies.get('rrc_login_phone'));
            }
            ndSubmitPopwin.show();
            ndInfotPopwin.show();
            ndSubmitPopwin.attr('rrc-tel-button', submitsource);
            ndSubmitPopwin.attr('rrc-sub-product', sub_product);
            ndDetailPopwin.attr('rrc-event-scope', eventscope).fullscreen('show');
            /* istanbul ignore next */
            if (popType === 'discount') {
                isFirstSubmitFullPrice = true;
                let imgType = 3;
                const man = $('.popwin-man-img');
                const option = {
                    price: RRC.carPrice,
                    discount: 0.95,
                    individual_low_price: LOWPRICE,
                    individual_high_price: HIGHPRICE,
                    onDrag(json) {
                        discount_pirce = json.price;
                        const progressType = that.getProgressType(json.progress);
                        if (progressType !== imgType) {
                            man.addClass('popwin-animation');
                            setTimeout(() => {
                                man.css('background-position-x', `${-(progressType - 1) * 100}px`);
                            }, 500);
                            imgType = progressType;
                        }

                        if (discount_pirce === (RRC.carPrice * LOWDISCOUNT).toFixed(2)) {
                            $('#js-detail-popwin-abtest .popwin-msg').html('<span class="detail-warning"><i class="iconfont icon-detailwarning24"></i>价格太低很难收到通知哦</span>');
                        } else {
                            $('#js-detail-popwin-abtest .popwin-msg').html(`<span class="advise-price">建议价:${LOWPRICE}万~${HIGHPRICE}万</span>`);
                        }
                    },
                    onInit(json) {
                        discount_pirce = json.price;
                        if (discount_pirce < LOWPRICE) {
                            $('#js-detail-popwin-abtest .popwin-msg').html('<span class="reasonable-price"><i class="iconfont icon-32zanzan"></i>价格合理，立即预约看车</span>');
                        }
                        $('#js-detail-popwin-abtest .popwin-msg').html(`<span class="advise-price">建议价:${LOWPRICE}万~${HIGHPRICE}万</span>`);
                    },
                };
                slidebar.init('#js-discount-slidebar', option);
                man.on('animationend', () => {
                    $(this).removeClass('popwin-animation');
                });
                $('#js-discount-slidebar').find('.salePrice-box').hide();
            }
            this.submitPopWin(popType);
            log.push(['_trackEvent', `pc-car-detail-${eventscope}-弹出`, 'click', { car_id: window.RRC.car_encrypt_id }]);
        },

        getProgressType(progress) {
            if (progress < (1 / 6) * 100) {
                return 1;
            } else if (progress < 50) {
                return 2;
            } else if (progress <= (5 / 6) * 100) {
                return 3;
            }
            return 4;
        },
        /*
        ** Abtest 降价弹层样式  结束***
        */

        // 关闭弹层
        closePopWinModal() {
            $('#js-detail-popwin-mask, #js-popwin-close').on('click', () => {
                $('#js-detail-popwin').hide();
                $('#main').css('overflow', 'auto');
            });
        },
        // 关闭弹层
        closePopWinModalAbtest() {
            $('#js-detail-popwin-mask, #js-popwin-close-abtest').on('click', () => {
                $('#js-detail-popwin-abtest').fullscreen('hide');
                $('#main').css('overflow', 'auto');
            });
        },

        // 为弹层单独封装的提线索方法
        popWinIntent(intentType) {
            const initData = {
                mobile_number: $.trim($('#popwin_mobile_number').val()),
                phone_source: $('#js-popwin-number-phone-source').val(),
            };
            /* istanbul ignore next */
            if (intentType === 'appointment') {
                appoint.init(initData, {
                    successMessage: util.getPCIntentSuccessTips('libao'),
                }, intentType);
                appoint.intentAppointent();
            } else if (intentType === 'discount') {
                const data = {
                    car_id: $('.detail-wrapper').data('id'),
                    mobile_number: $.trim($('#popwin_mobile_number').val()),
                    phone_source: `${$('#js-popwin-number-phone-source').val()}_降价通知`,
                    token: RRC.csrftoken,
                };
                const sub_product = $('#js-popwin-submit').attr('rrc-sub-product');
                if (sub_product) data.sub_product = sub_product;
                const success = (argument) => {
                    if (argument.status !== 400 && argument.status !== 401) {
                        dialog('提交成功', remind, '/dist/images/hongbao-692-0044a46c.png');
                        RRC.SHOW_DETAIL_LAYER_MASK = false;
                        _fxcmd.push(['trackEvent', 'event', 'cvr1', md5(data.mobile_number), '1']);
                    }
                };

                intent('discount_notify', data, success, '/dist/images/hongbao-692-0044a46c.png');
            }
        },

        // 为弹层单独封装的提线索方法
        popWinIntentAbtest(intentType) {
            const initData = {
                mobile_number: $.trim($('#popwin-mobile-number').val()),
                phone_source: $('#js-popwin-number-phone-source-abtest').val(),
            };
            /* istanbul ignore next */
            if (intentType === 'appointment') {
                appoint.init(initData, {
                    successMessage: util.getPCIntentSuccessTips('libao'),
                }, intentType);
                appoint.intentAppointent();
            } else if (intentType === 'discount') {
                const data = {
                    car_id: $('.detail-wrapper').data('id'),
                    mobile_number: $.trim($('#popwin-mobile-number').val()),
                    phone_source: `${$('#js-popwin-number-phone-source-abtest').val()}_降价通知`,
                    price: discount_pirce,
                    token: RRC.csrftoken,
                };
                const sub_product = $('#js-popwin-submit').attr('rrc-sub-product');
                if (sub_product) data.sub_product = sub_product;
                const success = (argument) => {
                    if (argument.status !== 400 && argument.status !== 401) {
                        dialog('提交成功', remind, '/dist/images/hongbao-692-0044a46c.png');
                        _fxcmd.push(['trackEvent', 'event', 'cvr1', md5(data.mobile_number), '1']);
                    }
                };

                intent('discount_notify', data, success, '/dist/images/hongbao-692-0044a46c.png');
            }
        },

        // 提交弹层信息
        submitPopWin(popType) {
            $('#js-detail-popwin .btn-schedule').click(() => {
                const $inMobile = $('#popwin_mobile_number');
                const $error = $('#js-popwin-error');
                const inMobile = $.trim($inMobile.val());
                /* istanbul ignore next */
                if (!util.validateMobile($inMobile, $error, inMobile)) {
                    return;
                }
                $('#js-detail-popwin').fullscreen('hide');
                this.popWinIntent(popType);
            });

            $('#js-detail-popwin-abtest .btn-schedule').click(() => {
                const $inMobile = $('#popwin-mobile-number');
                const $error = $('#js-popwin-error-abtest');
                const inMobile = $.trim($inMobile.val());
                /* istanbul ignore next */
                if (!util.validateMobile($inMobile, $error, inMobile)) {
                    return false;
                }
                /* istanbul ignore next */
                if (Number(discount_pirce) === Number(RRC.carPrice) && isFirstSubmitFullPrice) {
                    isFirstSubmitFullPrice = false;
                    $('#js-detail-popwin-abtest .popwin-msg').html('<span class="err-info"><i class="iconfont icon-detailwarning24"></i>您提交的是原价，请改价格</span>');
                    return false;
                }
                $('#js-detail-popwin-abtest').fullscreen('hide');
                this.popWinIntentAbtest(popType);
            });
        },

        // 弹层初始化
        init(poptype) {
            /* istanbul ignore next */
            if (this.canShowPopWin()) {
                this.showPopWinModal(poptype, __DEVELOPMENT__ ? 5000 : 60000);
                this.closePopWinModal();
            }
        },

        // 弹层初始化Abtest
        initAbtest(poptype) {
            /* istanbul ignore next */
            if (this.canShowPopWin()) {
                this.showPopWinModalAbtest(poptype, __DEVELOPMENT__ ? 5000 : 60000);
                this.closePopWinModalAbtest();
            }
        },
    };
});
